import {RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {AppModule} from './app.module';
import {authGuardFn} from "@auth0/auth0-angular";
import {environment} from "../environments/environment";

const routes: Routes = [
    {path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [authGuardFn]},
    {path: 'veranstaltungen', loadChildren: () => import('./veranstaltungen/veranstaltungen.module').then(m => m.VeranstaltungenModule), canActivate: [authGuardFn]},
    {path: 'kontakte', loadChildren: () => import('./kontakte/kontakte.module').then(m => m.KontakteModule), canActivate: [authGuardFn]},
    {path: 'settings', loadChildren: () => import('./settings/app-settings.module').then(m => m.AppSettingsModule), canActivate: [authGuardFn]},
    {path: '', pathMatch: 'full', redirectTo: () => environment.maintenanceMode ? 'login' : 'dashboard'},
    {path: 'login', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)},
    {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [authGuardFn]},
    {path: '**', redirectTo: '', pathMatch: 'full'}
];

export const ModuleRouting: ModuleWithProviders<AppModule> = RouterModule.forRoot(routes, {});
